import { useEffect, useRef, useState } from "react";

import { identity, isEqual, pickBy } from "lodash";

import type { File, FilesAPIResponse } from "./types";
import useFetchTax from "./use-fetch-tax";

type Props = {
  search?: {
    employee?: string;
  };
};

export default function useFiles(props: Props) {
  const { search } = props || {};
  const [files, setFiles] = useState<File[] | null>(null);
  const [error, setError] = useState<Error | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const {
    isLoading: useFetchTaxIsLoading,
    error: useFetchTaxError,
    get,
  } = useFetchTax();

  const searchRef = useRef(search);

  if (!isEqual(searchRef.current, search)) {
    searchRef.current = search;
  }

  useEffect(() => {
    if (searchRef.current === undefined || useFetchTaxIsLoading) {
      return;
    }

    (async function () {
      setIsLoading(true);
      try {
        const files = (await get("files", {
          searchParams: pickBy(searchRef.current, identity),
        })) as FilesAPIResponse;
        setFiles(files.data);
      } catch (e) {
        if (e instanceof Error) {
          setError(e);
        }
      } finally {
        setIsLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchRef.current, useFetchTaxIsLoading]);

  return {
    files: files,
    isLoading: isLoading || useFetchTaxIsLoading,
    error: error || useFetchTaxError,
  };
}
